import { Fragment } from 'react';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MessageActionsDropdownButton = ({
  buttonIcon: Icon,
  children,
  tooltipProps,
  disabled,
  onClick,
  'data-test-id': dataTestId = 'message-actions-dropdown-button'
}) => {
  const Wrapper = tooltipProps ? Tooltip : Fragment;
  return /*#__PURE__*/_jsx(Wrapper, Object.assign({}, tooltipProps, {
    children: /*#__PURE__*/_jsxs(Button, {
      use: "unstyled",
      onClick: onClick,
      "data-test-id": dataTestId,
      role: 'menuitem',
      disabled: disabled,
      children: [/*#__PURE__*/_jsx(Icon, {
        color: "icon-core-subtle"
      }), children]
    })
  }));
};
MessageActionsDropdownButton.displayName = 'MessageActionsDropdownButton';
export default MessageActionsDropdownButton;